import React, { useEffect, useState } from "react"
import { cloneOrder, Schema } from "../utils";
import { useCore } from "../hooks";
import { useNavigate, useParams } from "react-router";
import { Customer, Order } from "depoto-core";
import { Btn, Loader, ModalNotesOnExistingOrder, ModalPaymentsOnExistingOrder, OrderFinalSummary } from "../components";
import {printDocument} from "../utils/print.ts";

export const OrderDetail: React.FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  const { core, currentOrder, setCurrentOrder } = useCore()
  const [order, setOrder] = useState<Order>()

  useEffect(() => {
    if (params?.id) {
      getOrder(Number(params.id))
    }
  }, [params])

  const getOrder = async (orderId: number) => {
    const o = await core.services.order.getById(orderId, Schema.order.detail)
    setOrder(o)
  }

  const backToList = () => {
    navigate('/checkout-detail/orders')
  }

  const showPdf = (url?: string) => {
    core.services.download.downloadDocumentAndShowInNewWindow(url || order.invoiceReceiptUrl, false)
  }

  const printPdf = () => {
    if (window._depoto) {
      printDocument(order.invoiceReceiptUrl, false, true, core)
    } else {
      showPdf()
    }
  }

  const assignCustomer = async (customer: Customer | null) => {
    await core.services.order.updateOrderPart({
      id: order.id,
      customer: customer ? customer : null,
    })
    getOrder(Number(params.id))
  }

  const repeatOrder = () => {
    cloneOrder({ orderToClone: order, currentOrder, setCurrentOrder })
    navigate('/dashboard')
  }

  const returnOrder = async () => {
    const orderToReturn = {...order}
    orderToReturn.billNumber = null
    orderToReturn.reservationNumber = null
    orderToReturn.id = null
    orderToReturn.priority = 10
    orderToReturn.status = { id: 'bill', name: 'Objednávka' }
    orderToReturn.relatedParent = {...order}
    orderToReturn.items.forEach((_, i) => {
      orderToReturn.items[i].id = null
      orderToReturn.items[i].quantity = orderToReturn.items[i].quantity * -1
      orderToReturn.items[i].isForSubsequentSettlement = orderToReturn.items[i].isForSubsequentSettlement || false
    })
    orderToReturn.paymentItems.forEach((_, i) => {
      orderToReturn.paymentItems[i].amount = orderToReturn.paymentItems[i].amount * -1
    })
    orderToReturn.clearanceItems = []
    orderToReturn.priceAll = orderToReturn.priceAll * -1
    orderToReturn.rounding = orderToReturn.rounding * -1
    orderToReturn.note = `Vratka k objednávce číslo ${order.billNumber}`
    orderToReturn.dateCreated = (new Date()).toISOString().replace('T', ' ')
    console.log({orderToReturn})
    const resReturn = await core.services.order.create(orderToReturn, Schema.order.detail)
    // const resUpdate = await core.services.order.updateOrderPart({ id: resReturn.id, status: { id: 'bill', name: 'Objednávka' }}, Schema.order.detail)
    // console.log({resReturn, resUpdate})
    console.log({resReturn})
    if (window._depoto) {
      printDocument(resReturn.invoiceReceiptUrl, false, true, core)
    } else {
      showPdf(resReturn.invoiceReceiptUrl)
    }
    // navigate('/dashboard')
  }

  return order ? (
    <div className="h-body p-6 flex flex-col overflow-y-auto">
      <div className="bg-white border-b-1 border-solid border-border-light rounded-md p-6 mb-6">
        <div className="flex flex-row items-center">
          <h1 className="font-bold mr-4 text-xl">Daňový doklad: {order?.billNumber}</h1>
          <Btn className="btn-base-100" children={'Zpět na výpis'} icon={'fa-arrow-left'} onClick={backToList} />
        </div>
        <div className="flex flex-row gap-2 mt-4">
          <ModalNotesOnExistingOrder order={order} onUpdate={() => getOrder(Number(params.id))} />
          <ModalPaymentsOnExistingOrder order={order} onUpdate={() => getOrder(Number(params.id))} />
          <Btn className="btn-base-100" children={'Pdf účtenka'} icon={'far fa-file-pdf'} onClick={() => showPdf()} />
          <Btn className="btn-base-100" children={'Zrušit (celé dobropisovat)'} icon={'far fa-arrow-rotate-left'} onClick={returnOrder} />
          <Btn className="btn-base-100" children={'Znovu objednat'} icon={'far fa-arrow-rotate-right'} onClick={repeatOrder} />
          <Btn className="btn-primary" children={'Vytisknout účtenku'} icon={'far fa-print'} onClick={printPdf} />
        </div>
      </div>
      <div className="w-1/2">
        {<OrderFinalSummary order={order} isReservation={false} showCustomerHeader={false} onExistingOrderCustomerChange={assignCustomer} />}
      </div>
    </div>
  ) : <Loader />
}
